const theme = {
  grey100: "#fafafa",
  grey150: "#f2f3f3",
  grey200: "#eaeded",
  grey300: "#d5dbdb",
  grey400: "#aab7b8",
  grey450: "#95a5a6",
  grey500: "#879596",
  grey550: "#687078",
  grey600: "#545b64",
  grey650: "#414750",
  grey700: "#2a2e33",
  grey750: "#21252c",
  grey800: "#1a2029",
  grey900: "#16191f",
  grey950: "#222",
  greyTransparentHeavy: "rgba(0,28,36,0.5)",
  greyTransparent: "rgba(0,28,36,0.3)",
  greyTransparentLight: "rgba(0,28,36,0.15)",
  greyOpaque25: "hsla(0,0%,100%,0.25)",
  greyOpaque40: "rgba(0,0,0,0.4)",
  greyOpaque50: "rgba(0,0,0,0.5)",
  greyOpaque70: "hsla(0,0%,100%,0.7)",
  greyOpaque80: "rgba(22,25,31,0.8)",
  greyOpaque90: "rgba(242,243,243,0.9)",
  orange100: "#fef6f0",
  orange300: "#f7bf9c",
  orange500: "#ec7211",
  orange600: "#eb5f07",
  orange700: "#dd6b10",
  blue100: "#f1faff",
  blue300: "#99cbe4",
  blue400: "#44b9d6",
  blue500: "#00a1c9",
  blue600: "#0073bb",
  blue700: "#0a4a74",
  blue900: "#12293b",
  blueOpaque: "rgba(51,136,221,0.5)",
  green100: "#f2f8f0",
  green300: "#a5d099",
  green500: "#6aaf35",
  green600: "#1d8102",
  green700: "#1a520f",
  green900: "#172211",
  red100: "#fdf3f1",
  red300: "#f2ada0",
  red500: "#ff5d64",
  red600: "#d13212",
  red700: "#7c2718",
  red900: "#270a11",
  black: "#000",
  white: "#fff",
  awsSquidInk: "#232f3e",
  amazonOrange: "#f90",
  textBodyDefault: "#16191f",
  textBodySecondary: "#545b64",
  textHeadingDefault: "#16191f",
  textHeadingSecondary: "#545b64",
  textHomeHeaderDefault: "#fff",
  textHomeHeaderSecondary: "#d5dbdb",
  textLabel: "#545b64",
  textAccent: "#ec7211",
  textEmpty: "#687078",
  textLinkDefault: "#0073bb",
  textInteractiveDefault: "#545b64",
  textInteractiveDisabled: "#aab7b8",
  textInteractiveActive: "#16191f",
  textInteractiveHover: "#16191f",
  textSmall: "#687078",
  textInverted: "#fff",
  textDisabled: "#aab7b8",
  textFormDefault: "#16191f",
  textFormSecondary: "#687078",
  textFormLabel: "#16191f",
  textInputDisabled: "#879596",
  textInputPlaceholder: "#aab7b8",
  textControlDisabled: "#aab7b8",
  textStatusError: "#d13212",
  textStatusWarning: "#d13212",
  textStatusSuccess: "#1d8102",
  textStatusInfo: "#0073bb",
  textStatusInactive: "#687078",
  textStatusPending: "#687078",
  textBreadcrumb: "#687078",
  textIconCaret: "#879596",
  textIconSubtle: "#687078",
  textColumnHeader: "#545b64",
  textTooltipDefault: "#d5dbdb",
  textTooltipLink: "#00a1c9",
  textDropdownItemDefault: "#16191f",
  textDropdownItemHighlighted: "#16191f",
  textDropdownItemSecondary: "#687078",
  textDropdownItemDisabled: "#aab7b8",
  textDropdownItemFilterMatch: "#0073bb",
  textDropdownGroupLabel: "#545b64",
  textDropdownFooter: "#687078",
  textNotificationDefault: "#fafafa",
  textNotificationIconDefault: "#d5dbdb",
  textNotificationIconHover: "#fafafa",
  foregroundControlDefault: "#fff",
  foregroundControlDisabled: "#fff",
  backgroundHomeHeader: "#232f3e",
  backgroundLayoutMain: "#f2f3f3",
  backgroundLayoutPanelContent: "#fff",
  backgroundLayoutPanelHover: "#eaeded",
  backgroundItemSelected: "#f1faff",
  backgroundModalOverlay: "rgba(242,243,243,0.9)",
  backgroundStatusError: "#fdf3f1",
  backgroundStatusWarning: "#fff",
  backgroundStatusSuccess: "#f2f8f0",
  backgroundStatusInfo: "#f1faff",
  backgroundProgressBarLayoutDefault: "#eaeded",
  backgroundProgressBarLayoutInFlash: "hsla(0,0%,100%,0.25)",
  backgroundProgressBarContentDefault: "#0073bb",
  backgroundProgressBarContentInFlash: "hsla(0,0%,100%,0.7)",
  backgroundCalendarToday: "#f2f3f3",
  backgroundContainerHeader: "#fafafa",
  backgroundContainerContent: "#fff",
  backgroundControlDefault: "#fff",
  backgroundControlChecked: "#0073bb",
  backgroundControlDisabled: "#d5dbdb",
  backgroundInputDefault: "#fff",
  backgroundInputDisabled: "#eaeded",
  backgroundTilesDisabled: "#eaeded",
  backgroundTooltip: "#16191f",
  backgroundPopover: "#fff",
  backgroundToggleDefault: "#545b64",
  backgroundToggleCheckedDisabled: "#99cbe4",
  backgroundButtonNormalDefault: "#fff",
  backgroundButtonNormalDisabled: "#fff",
  backgroundButtonNormalHover: "#fafafa",
  backgroundButtonNormalActive: "#eaeded",
  backgroundButtonPrimaryDefault: "#ec7211",
  backgroundButtonPrimaryDisabled: "#fff",
  backgroundButtonPrimaryHover: "#eb5f07",
  backgroundButtonPrimaryActive: "#dd6b10",
  backgroundButtonLinkHover: "#fafafa",
  backgroundButtonLinkActive: "#eaeded",
  backgroundDropdownItemDefault: "#fff",
  backgroundDropdownItemSelected: "#f1faff",
  backgroundDropdownItemHover: "#f2f3f3",
  backgroundDropdownItemFilterMatch: "#f1faff",
  backgroundNotificationGrey: "#545b64",
  backgroundNotificationGreen: "#1d8102",
  backgroundNotificationBlue: "#0073bb",
  backgroundNotificationRed: "#d13212",
  borderItemFocused: "#00a1c9",
  borderItemSelected: "#00a1c9",
  borderStatusSuccess: "#1d8102",
  borderStatusError: "#d13212",
  borderStatusWarning: "#aab7b8",
  borderStatusInfo: "#0073bb",
  borderContainerTop: "#eaeded",
  borderControlDefault: "#aab7b8",
  borderControlChecked: "#0073bb",
  borderControlDisabled: "#d5dbdb",
  borderControlHover: "#879596",
  borderInputDefault: "#aab7b8",
  borderInputDisabled: "#eaeded",
  borderSegmentDefault: "#687078",
  borderSegmentHover: "#16191f",
  borderTilesDisabled: "transparent",
  borderTabs: "#aab7b8",
  borderTooltip: "#16191f",
  borderPopover: "#d5dbdb",
  borderButtonNormalDefault: "#545b64",
  borderButtonNormalHover: "#16191f",
  borderButtonNormalDisabled: "#d5dbdb",
  borderButtonPrimaryHover: "#dd6b10",
  borderButtonPrimaryDisabled: "#d5dbdb",
  borderDropdownItemDefault: "#eaeded",
  borderDropdownItemSelected: "#00a1c9",
  borderDropdownItemHover: "#879596",
  borderDropdownItemTop: "#eaeded",
  borderDropdownGroup: "#eaeded",
  borderDividerDefault: "#eaeded",
  borderDividerActive: "#879596",
  borderLayout: "#d5dbdb",
  shadowDefault: "rgba(0,28,36,0.5)",
  shadowMedium: "rgba(0,28,36,0.3)",
  shadowSide: "rgba(0,28,36,0.15)",
};
export default theme;
